'use strict';

/**
 * Directive: anthro-modal
 *
 * Fires up a centered modal with an overlay and close button.
 * To use, just add a unique value (modalName) to the attribute.
 * ex. <div anthro-modal="subscription"></div>
 */
module.exports = /*@ngInject*/
function(
    $rootScope,
    AnthroConfig
) {
    return {
        transclude: true,
        scope: {
            modalName: '@anthroModal'
        },
        templateUrl: AnthroConfig.location.root + '/partials/anthro-modal.html',
        link: function(scope, element, attrs) {
            element.on('click', '[data-modal-close]', function(e) {
                closeModal(scope.modalName);
            });

            angular.element('[data-modal-open]').on('click', function(e) {
                openModal(scope.modalName);
            });

            $rootScope.$on('modal:open', function(event, modalName) {
                openModal(modalName);
            });

            $rootScope.$on('modal:close', function(event, modalName) {
                closeModal(modalName);
            });

            function openModal(modalName) {
                angular.element('.' + modalName + '-modal').addClass('active');
                angular.element('.body-wrapper').addClass('anthro-modal-active');
            }

            function closeModal(modalName) {
                angular.element('.' + modalName + '-modal').removeClass('active');
                angular.element('.body-wrapper').removeClass('anthro-modal-active');
            }
        }
    };
};
